import { useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import { IconButton, Text } from "../UI";
import close from "../asserts/img/red-close.svg";
import error from "../asserts/img/error.svg";
import { useTranslation } from "react-i18next";

const Container = styled("div")(() => ({
  width: "fit-content",
  minHeight: 54,
  display: "flex",
  flexDirection: "row",
  backgroundColor: "#FBEBEE",
  color: "red",
  position: "absolute",
  bottom: 15,
  left: 0,
  right: 0,
  margin: "0 auto",
  marginBottom: 30,
  gap: 10,
  padding: "14px 20px 14px 20px",
  borderRadius: 12,
  alignItems: "center",
  zIndex: 99999,
}));

const Line = styled("div")(({ isRtl }) => ({
  "&::after": {
    content: "''",
    position: "absolute",
    height: "30px",
    width: "1px",
    borderRight: `1px dotted #D92D20`,
    top: 0,
    bottom: 0,
    margin: "auto",
    left: isRtl ? 60 : "unset",
    right: !isRtl ? 60 : "unset",
    zIndex: 99999,
  },
}));

const AUTO_DISMISS_MS = 8000;

const ErrorNotification = ({ text, onClose, withAction = false }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  // Latest onClose in a ref: the timer starts once and isn't restarted by parent re-renders
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const timer = setTimeout(() => {
      onCloseRef.current();
    }, AUTO_DISMISS_MS);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container>
      <img alt="" src={error} />
      <div style={{ maxWidth: 525, marginInlineEnd: 12 }}>
        <Text color={"#D92D20"}> {text} </Text>
      </div>
      <Line isRtl={isRtl} />
      <IconButton
        src={close}
        iconSize={24}
        label={t("common:close")}
        style={{ marginInlineStart: withAction ? "unset" : "auto" }}
        onClick={() => {
          onClose();
        }}
      />
    </Container>
  );
};

export default ErrorNotification;
